import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 24px;
    height: 100%;
    justify-content: center;
    width: 100%;
  `}
`;

export const FooterText = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin-top: 32px;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    
     > button {
      display: block;
      margin-bottom: 2px;

      svg {
        fill: ${theme.v2.colors.brand.primaryMedium};
        left: 4px;
        position: relative;
        top: 4px;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      margin-bottom: 32px;
    }
  `}
`;

export const OptionsWrapper = styled.ul`
  ${({ theme }) => css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  justify-content: center;
  list-style-type: none;
  margin: 32px 0 0;
  padding: 0;
  max-width: 960px;

  > ${FooterText} {
    grid-column: 1 / -1;
    margin-top: 0;
  }

  @media (max-width: ${theme.v2.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 24px;
    margin: 16px auto;
    padding: 0;
    background-color: ${theme.v2.colors.neutral.highPure};
    align-items: center;
    justify-items: center;
  }
  `}
`;

export const IconAdapter = styled.div``;

export const BtnAdapter = styled.div`
  ${({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-bottom: 4px;
    width: 17px;
      height: 17px;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    border-radius: 16px;
    border: 1px solid ${theme.v2.colors.neutral.highLight};
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 443px;
    height: 544px;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 328px;
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    width: 443px;
    height: 200px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      height: 180px;
    }
  `}
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px;
      gap: 16px;
    }
      @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 24px 16px 24px 24px;
    }
  `}
`;

export const OptionRow = styled.span`
  ${({ theme }) => css`
    align-item: center;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    > button {
      display: block;
      svg {
        fill: ${theme.v2.colors.brand.primaryMedium};
        left: 10px;
        position: relative;
        top: 3px;
      }
    }
  `}
`;

export const TagWrapper = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #29d195a8 0%, #038DF3 100%);
    border-radius: 100px;
    padding: 4px 12px;
    display: inline-flex;
    align-items: center;
    margin-left: 12px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-left: 0;
    }
  `}
`;

export const TagText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: baseline;
  > div:first-child {
    display: flex;
    align-items: center;
  }
`;

export const OptionTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;
  `};
`;

export const OptionDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;
    text-align: left;
    align-items: center;
  `};
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: left;
  `};
`;

export const OptionRowLast = styled.div`
  ${({ theme }) => css`
    align-item: center;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 4px;
    > button {
      display: block;
      margin-bottom: 2px;
      svg {
        fill: ${theme.v2.colors.brand.primaryMedium};
        left: 4px;
        position: relative;
        top: 4px;
      }
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }
  `}
`;

export const OptionSubDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;
    text-align: center;
    align-items: center;
  `};
`;

export const TitleAdapter = styled.div`
  ${({ theme }) => css`
    display: flex;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column-reverse;
      justify-content: flex-start;
      gap: 4px;
      margin-top: 8px;
      align-items: flex-start;
    }
  `}
`;
